import { render, staticRenderFns } from "./systemFrom.vue?vue&type=template&id=47c05548&"
import script from "./systemFrom.vue?vue&type=script&lang=ts&"
export * from "./systemFrom.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports